import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
const loadReturnPortalLoginModule = () => ({
    hasRouter: false,
    modules: [loadSessionModule(), loadAuthenticationModule()],
});
export default loadReturnPortalLoginModule;
